import { DateTime } from "luxon";

const BLOG_DATE_ZONE = "America/Chicago";

export const BlogPostDate = ({
  createdAt,
  updatedAt,
}: {
  createdAt: string;
  updatedAt: string;
}) => {
  const createdDate = DateTime.fromISO(createdAt, { zone: BLOG_DATE_ZONE });
  const updatedDate = DateTime.fromISO(updatedAt, { zone: BLOG_DATE_ZONE });

  if (!updatedDate.isValid) return null;

  const isMeaningfullyUpdated =
    createdDate.isValid && updatedDate.diff(createdDate, "days").days > 1;

  return (
    <>
      {isMeaningfullyUpdated && "Updated "}
      <time dateTime={updatedDate.toISODate() ?? undefined}>
        {updatedDate.toLocaleString(DateTime.DATE_MED)}
      </time>
    </>
  );
};
